import React from 'react';
import './main.css';


const Separator = () => {
    return <div className="separator"></div>;
}

export default Separator;
